module.exports = __webpack_public_path__ + "static/bg-78bbc4b56f81e8da16c23a9b8486e32f.jpg";